import { render } from "./SightCreate.vue?vue&type=template&id=28db876c"
import script from "./SightCreate.vue?vue&type=script&lang=js"
export * from "./SightCreate.vue?vue&type=script&lang=js"

import exportComponent from "/home/travelcrm/travel-crm-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__